// extracted by mini-css-extract-plugin
module.exports = {"firstButton":"DoubleButton_firstButton__1vAEA","secondButton":"DoubleButton_secondButton__XfR3f"};